import { FormDialog } from 'components/dialog/form'
import { SearchResult, useEditSearchDescription } from 'interface/search'
import { SearchsDescriptionForm, useSearchsDescriptionForm } from '../form/searchsDescriptionForm'

type EditSearchsDescriptionDialogProps = {
  search: SearchResult
  onSubmit: (result: SearchResult) => void
  onClose: () => void
}
export const EditSearchsDescriptionDialog = ({
  search,
  onSubmit,
  onClose
}: EditSearchsDescriptionDialogProps) => {
  const form = useSearchsDescriptionForm(search)
	const {
		form: {
			formState: { isValid },
			handleSubmit
		}
	} = form
  const [postState, submit] = useEditSearchDescription(search.searchId, { onEditted: onSubmit })

  return (
    <FormDialog
      open
      fullWidth
      maxWidth='md'
      title="メモを編集"
      isLoading={postState.posting}
      error={postState.error}
      body={<SearchsDescriptionForm {...form}/>}
      submitLabel="更新"
      isValid={isValid}
      onSubmit={handleSubmit(submit)}
      onClose={onClose}
    />
  );
}
